<div class="guest-confirmation-container">
  <div class="certificate-card">
    <div class="certificate-decoration">
      <img
        src="/assets/images/certificate-decoration.png"
        alt="Decorative waves"
        class="decoration-image"
      />
    </div>

    <div class="certificate-text">
      <div class="icon-container">
        <svg xmlns="http://www.w3.org/2000/svg" class="success-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <h1 class="title">{{ 'common.guestConfirmation.title' | translate }}</h1>
      <p class="message">{{ 'common.guestConfirmation.message' | translate }}</p>

      <div class="certificate-logo">
        <img
          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='40' viewBox='0 0 120 40'%3E%3Ctext x='10' y='25' font-family='Arial' font-size='14' font-weight='bold' fill='%23003d6b'%3EG-CONSULTING%3C/text%3E%3Ctext x='10' y='35' font-family='Arial' font-size='8' fill='%23666'%3ECOMPLIANCE%3C/text%3E%3C/svg%3E"
          alt="GConsulting Logo"
        />
      </div>
    </div>
  </div>
</div>
